import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ec1a346"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = { class: "text-xs text-gray-500 mt-5" }
const _hoisted_4 = { class: "h-full max-h-full" }
const _hoisted_5 = { class: "text-xl md:text-xl font-bold" }
const _hoisted_6 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-5",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Betroffene Flurstücke", -1))
const _hoisted_11 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Typ", -1))
const _hoisted_13 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Zu schützendes Objekt - Art", -1))
const _hoisted_15 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Zu schützendes Objekt - Abmessung", -1))
const _hoisted_17 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-7" }, "Zu schützendes Objekt - Bewertung", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Länge des Schutzgerüstes", -1))
const _hoisted_20 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Breite der geplanten Gerüstwände", -1))
const _hoisted_22 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Höhe Gerüstwände", -1))
const _hoisted_24 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Spannweite des Netzes", -1))
const _hoisted_26 = { class: "col-span-5 text-xs text-gray-500" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Abstand zur bestehenden/geplanten überkreuzenden Freileitung", -1))
const _hoisted_28 = { class: "col-span-5 text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_bewertung_chip = _resolveComponent("bewertung-chip")!
  const _component_is_vorhanden_char_and_label = _resolveComponent("is-vorhanden-char-and-label")!
  const _component_be_footer = _resolveComponent("be-footer")!
  const _component_pdf_a_4_page = _resolveComponent("pdf-a-4-page")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSchutzgerueste(_ctx.ba), (geruest, index) => {
    return (_openBlock(), _createElementBlock("span", { key: index }, [
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_3, "Schutzgerüste > Schutzgerüst " + _toDisplayString(index + 1), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, "Schutzgerüst " + _toDisplayString(index + 1), 1),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, _toDisplayString(geruest.findFrageByRelativePath(_ctx.ba, 'betroffeneflurstuecke')?.getCurrentInput()), 1),
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(geruest.findFrageByRelativePath(_ctx.ba, 'typ')?.getSelectedAuswahlLabelsString()), 1),
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(geruest.findFrageByRelativePath(_ctx.ba, 'schuetzendes-objekt-art')?.getCurrentInput()), 1),
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(geruest.findFrageByRelativePath(_ctx.ba, 'schuetzendes-objekt-abmessung')?.getCurrentInput()), 1),
                  _hoisted_18,
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: geruest,
                    fragesPath: "schuetzendes-objekt-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(geruest.findFrageByRelativePath(_ctx.ba, 'laenge-schutzgeruest')?.getCurrentInput() 
                      ? geruest.findFrageByRelativePath(_ctx.ba, 'laenge-schutzgeruest')?.getCurrentInput() + " m" 
                      : "-"), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: geruest,
                    fragesPath: "laenge-schutzgeruest-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, _toDisplayString(geruest.findFrageByRelativePath(_ctx.ba, 'breite-geruestwaende')?.getCurrentInput() 
                      ? geruest.findFrageByRelativePath(_ctx.ba, 'breite-geruestwaende')?.getCurrentInput() + " m" 
                      : "-"), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: geruest,
                    fragesPath: "breite-geruestwaende-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(geruest.findFrageByRelativePath(_ctx.ba, 'hoehe-geruestwaende')?.getCurrentInput() 
                      ? geruest.findFrageByRelativePath(_ctx.ba, 'hoehe-geruestwaende')?.getCurrentInput() + " m" 
                      : "-"), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: geruest,
                    fragesPath: "hoehe-geruestwaende-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, _toDisplayString(geruest.findFrageByRelativePath(_ctx.ba, 'spannweite-netz')?.getCurrentInput() 
                      ? geruest.findFrageByRelativePath(_ctx.ba, 'spannweite-netz')?.getCurrentInput() + " m" 
                      : "-"), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: geruest,
                    fragesPath: "spannweite-netz-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: geruest,
                    ba: _ctx.ba,
                    fragesPath: "entfernung-hoehe-geruestwaende",
                    label: "Entfernung der Abspannung entpricht der Höhe der Gerüstwand",
                    class: "col-span-7"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: geruest,
                    fragesPath: "entfernung-hoehe-geruestwaende-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, _toDisplayString(geruest.findFrageByRelativePath(_ctx.ba, 'abstand-freileitung')?.getCurrentInput() 
                      ? geruest.findFrageByRelativePath(_ctx.ba, 'abstand-freileitung')?.getCurrentInput() + " m" 
                      : "-"), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: geruest,
                    fragesPath: "abstand-freileitung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ])
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"])
    ]))
  }), 128))
}